module.exports = __webpack_public_path__ + "img/btn-sign-in-with-google-light.4c333e27.png";